import { render, staticRenderFns } from "./note_card.vue?vue&type=template&id=290bbf01&scoped=true&"
import script from "./note_card.vue?vue&type=script&lang=js&"
export * from "./note_card.vue?vue&type=script&lang=js&"
import style0 from "./note_card.vue?vue&type=style&index=0&id=290bbf01&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290bbf01",
  null
  
)

export default component.exports